document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', function () {
  /* ---------- Mobile nav ---------- */
  var navToggle = document.querySelector('[data-nav-toggle]');
  var navClose = document.querySelector('[data-nav-close]');
  var nav = document.querySelector('[data-site-nav]');
  var overlay = document.querySelector('[data-nav-overlay]');

  function openNav() {
    if (nav) nav.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeNav() {
    if (nav) nav.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  if (navToggle) navToggle.addEventListener('click', openNav);
  if (navClose) navClose.addEventListener('click', closeNav);
  if (overlay) overlay.addEventListener('click', closeNav);

  /* ---------- Search modal ---------- */
  var searchToggle = document.querySelectorAll('[data-search-toggle]');
  var searchModal = document.querySelector('[data-search-modal]');
  var searchClose = document.querySelector('[data-search-close]');
  searchToggle.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (searchModal) {
        searchModal.classList.add('is-open');
        var input = searchModal.querySelector('input[type="search"]');
        if (input) setTimeout(function () { input.focus(); }, 50);
      }
    });
  });
  if (searchClose) {
    searchClose.addEventListener('click', function () {
      searchModal.classList.remove('is-open');
    });
  }
  if (searchModal) {
    searchModal.addEventListener('click', function (e) {
      if (e.target === searchModal) searchModal.classList.remove('is-open');
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeNav();
      if (searchModal) searchModal.classList.remove('is-open');
    }
  });

  /* ---------- Accordions (product details) ---------- */
  document.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var item = trigger.closest('[data-accordion-item]');
      var panel = item.querySelector('[data-accordion-panel]');
      var isOpen = item.classList.contains('is-open');
      item.classList.toggle('is-open');
      if (panel) {
        panel.style.maxHeight = isOpen ? null : panel.scrollHeight + 'px';
      }
    });
  });

  /* ---------- Quantity selectors ---------- */
  document.querySelectorAll('[data-quantity-selector]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var minus = wrap.querySelector('[data-quantity-minus]');
    var plus = wrap.querySelector('[data-quantity-plus]');
    if (minus) minus.addEventListener('click', function () {
      var val = Math.max(1, parseInt(input.value || '1', 10) - 1);
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (plus) plus.addEventListener('click', function () {
      var val = parseInt(input.value || '1', 10) + 1;
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* ---------- Product gallery thumbnail swap ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main-img]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (main) main.src = thumb.dataset.fullSrc || thumb.src;
      });
    });
  });

  /* ---------- Simple zoom on click ---------- */
  document.querySelectorAll('[data-zoom-image]').forEach(function (img) {
    img.addEventListener('click', function () {
      img.classList.toggle('is-zoomed');
      img.style.cursor = img.classList.contains('is-zoomed') ? 'zoom-out' : 'zoom-in';
      img.style.transform = img.classList.contains('is-zoomed') ? 'scale(1.6)' : 'scale(1)';
      img.style.transition = 'transform .3s ease';
    });
  });

  /* ---------- Sticky mobile add-to-cart ---------- */
  var stickyAtc = document.querySelector('[data-sticky-atc]');
  var mainAtcBtn = document.querySelector('[data-main-atc]');
  if (stickyAtc && mainAtcBtn) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyAtc.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    io.observe(mainAtcBtn);
  }

  /* ---------- Variant swatch selection UI ---------- */
  document.querySelectorAll('[data-swatch-list]').forEach(function (list) {
    list.querySelectorAll('[data-swatch]').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        list.querySelectorAll('[data-swatch]').forEach(function (s) { s.classList.remove('is-selected'); });
        swatch.classList.add('is-selected');
        var input = swatch.querySelector('input');
        if (input) input.checked = true;
        swatch.dispatchEvent(new Event('variant:change', { bubbles: true }));
      });
    });
  });

  /* ---------- Newsletter form UX (no page reload feel) ---------- */
  document.querySelectorAll('form.newsletter-form').forEach(function (form) {
    form.addEventListener('submit', function () {
      var msg = form.querySelector('[data-newsletter-success]');
      if (msg) msg.hidden = false;
    });
  });

  /* ---------- Product recommendations (fetched via Shopify's recommendations API) ---------- */
  var recWrap = document.querySelector('[data-recommendations-url]');
  if (recWrap) {
    fetch(recWrap.dataset.recommendationsUrl)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newContent = doc.querySelector('[data-recommendations-url]');
        if (newContent && newContent.innerHTML.trim()) {
          recWrap.innerHTML = newContent.innerHTML;
        } else {
          var section = recWrap.closest('section');
          if (section) section.style.display = 'none';
        }
      })
      .catch(function () {});
  }
});
